import { ButtonLink } from '@/components/ui/Button'
import { Page } from '@/components/ui/Page'

export function NotFoundPage() {
  return (
    <Page>
      <div className="flex flex-col items-start gap-4 py-20">
        <p className="label">404</p>
        <h1 className="text-[length:var(--text-2xl)]">There is nothing at this address</h1>
        <p className="measure text-[length:var(--text-sm)] text-taupe">
          The link may be from an older version of the studio, or a record that has since been archived.
        </p>
        <ButtonLink to="/" variant="primary" className="mt-1">
          Back to the studio
        </ButtonLink>
      </div>
    </Page>
  )
}
